import { ISingleIdParams } from '../types/actionParams';
import { DatabaseAllowedActions } from '../types/DatabaseAllowedActions';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetDatabaseActionsRequest extends Request<ISingleIdParams, DatabaseAllowedActions> {
  constructor(id: string) {
    super('getDatabaseActions', { id: id });
  }
}
